import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import '../../../node_modules/react-multi-carousel/lib/styles.css';
import PropTypes from 'prop-types';
import {
    Container, Typography, Grid, Box,
    Divider
} from '@mui/material';
import Button from '@mui/material/Button';
import { List as IList, Map as IMap } from 'immutable';

import Alert from '@mui/material/Alert';
import windowSize from '../../utils/windowSize';
import GiftCardDeliveryTypeOptions from '../GiftCardDeliveryTypeOptions';
import CategoryTabsCarouselContainer from '../CategoryPage/CategoryTabsCarouselContainer';
import { getFormattedAmountWithCurrency } from '../../utils/numberUtils';
import { PHYSICAL_CARD_TYPE } from '../../productCartHandler/productCartModule';
import {
    saveSelectedCardOnBuyButtonClick, categoryDropdownSelectClick, selectedCardType, setClickedOnUYO
} from '../../landingPage/landingPageModule';
import homePageV2Messages from '../assets/messages/homePageMessages';
import SkeletonLoader from '../../loader/SkeletonLoader';
import { getPhase2Preferred, getPreferredCurrencyCode } from '../../app/bootstrap';
import SiteSwitchDialog from '../../localeCurrencyPicker/SiteSwitchDialog';
import { getCartCurrencyCode, getRemainingPlasticCardsAllowed } from '../../productCartHandler/productCartSelectors';
import {
    getBrandElectronicCurrencyList,
    getBrandPlasticCurrencyList,
    getCartMaxNumPlasticCards, getEgcRangedCatalogForCurrency, getFixedEgcCatalogForCurrency,
    getFixedPlasticCatalogForCurrency, getIsFixedEgcCatalogPresentForCurrency,
    getIsFixedPlasticCatalogPresentForCurrency, getPlasticRangedCatalogForCurrency, getUYOEgcPhotoSupported,
    getUYOPlasticPhotoSupported
} from '../../brand/brandSelectors';
import { CARD_TYPES } from '../../constants/constants';
import DenomCurrencyPicker from '../../giftCardDetailsPage_v2/DenomCurrencyPicker';
import { getIntlCurrencyCode } from '../../intl/intlSelectors';
import { setCurrency as setCurrencyActionCreator } from '../../intl/intlModule';
import { getCurrencyDefault } from '../../intl/intlSagas';
import UYOButton from '../../common/UYOButton';
import { getSelectedFaceplate } from '../../landingPage/landingPageSelectors';
import { trackButtonClick } from '../../segment/segmentModule';
import { HOME_STEP } from '../../routing/flowConstants';

const CarouselContainer = ({
    categories,
    handleSubmit,
    intl,
    giftCardMainTitle,
    giftCardDeliveryType,
    submitButtonName,
    digitalPrimaryFaceplate,
    saveSelectedCardOnBuyButtonClickAction,
    isLoading,
    categoryDropdownSelectClickAction,
    remainingPlasticCardsAllowed,
    cartMaxNumPlasticCards,
    saveSelectedCardType,
    physicalPrimaryFacePlate,
    selectedCurrency,
    supportedElectronicCurrencyList,
    supportedPlasticCurrencyList,
    setCurrency,
    cartCurrencyCode,
    uyoEgcPhotoSupported,
    uyoPlasticPhotoSupported,
    selectedFaceplate,
    setClickedOnUYOAction,
    trackAddAnotherButton
}) => {
    const [isMaxPhysicalItemModalOpen, setIsMaxPhysicalItemModalOpen] = useState(false);

    const handleMaxLimitModalClose = value => setIsMaxPhysicalItemModalOpen(value);

    
    const handleMaxLimitModalOpen = () => setIsMaxPhysicalItemModalOpen(true);
    const categoryCount = categories.count();
    const [faceplatesCount, setFaceplatesCount] = useState(null);

    const [isDialogOpen, setDialogOpen] = React.useState(false);
    const handleCloseModel = value => setDialogOpen(value);
    const handleClickForModal = () => setDialogOpen(true);

    const isPhysicalCard = giftCardDeliveryType === PHYSICAL_CARD_TYPE;
    const cardDeliveryType = isPhysicalCard ? CARD_TYPES.Physical : CARD_TYPES.Digital;

    const isPhotoSupported = isPhysicalCard ? uyoPlasticPhotoSupported : uyoEgcPhotoSupported;
    const [uyoFaceplate, setUyoFaceplate] = useState(null);
    useEffect(() => {
    
        if (selectedFaceplate.get('imageURL')?.includes('ucarecdn.com')) {
            setUyoFaceplate(selectedFaceplate);
        }
    }, [selectedFaceplate]);

    
    const currencyList = isPhysicalCard ? supportedPlasticCurrencyList : supportedElectronicCurrencyList;
    const currencyExistsInList = currencyList.includes(selectedCurrency);

    let initialCurrency = selectedCurrency;

    
    const preferredCurrencyCode = getPreferredCurrencyCode();
    const defaultCurrency = getCurrencyDefault(supportedElectronicCurrencyList, preferredCurrencyCode, isPhysicalCard, supportedPlasticCurrencyList);

    const hidePicker = cartCurrencyCode && !currencyExistsInList;

    const hideDenomPicker = supportedPlasticCurrencyList.size <= 1 && supportedElectronicCurrencyList.size <= 1;

    if (!currencyExistsInList && !hidePicker) {
        initialCurrency = defaultCurrency;
    }

    const [tempCurrency, setTempCurrency] = React.useState(initialCurrency);
    const isSetCurrency = false;

    const isFixedCatalog = isPhysicalCard ? useSelector(getIsFixedPlasticCatalogPresentForCurrency(tempCurrency)) : useSelector(getIsFixedEgcCatalogPresentForCurrency(tempCurrency));
    let catalogRange;
    if (isFixedCatalog) {
        catalogRange = isPhysicalCard ? useSelector(getFixedPlasticCatalogForCurrency(tempCurrency)) : useSelector(getFixedEgcCatalogForCurrency(tempCurrency));
    } else {
        catalogRange = isPhysicalCard ? useSelector(getPlasticRangedCatalogForCurrency(tempCurrency)) : useSelector(getEgcRangedCatalogForCurrency(tempCurrency));
    }

        const defaultFaceplate = isPhysicalCard
        ? physicalPrimaryFacePlate
        : digitalPrimaryFaceplate;
    const defaultCategory = categories.get(0);

    
    const CTAButtonOnClick = (faceplate, submitButtonTitleName, isPhysicalCardType, isMaxPhysicalModelOpen = false) => {
        if (!isMaxPhysicalModelOpen) {
            setCurrency(tempCurrency);
        }
        
        saveSelectedCardOnBuyButtonClickAction(defaultCategory,
            faceplate,
            submitButtonTitleName,
            isPhysicalCardType);
        setClickedOnUYOAction(false);
        handleSubmit(isPhysicalCardType);
    };
    const catalogStartRange = isFixedCatalog ? catalogRange && Number(catalogRange.get(0)) : catalogRange && Number(catalogRange.get('start'));
    const catalogEndRange = isFixedCatalog ? Number(catalogRange.get(catalogRange.size - 1)) : catalogRange && Number(catalogRange.get('end'));

    
    const callbackOnCategorySelectOrClose = (categoryDropdownClickData) => {
        categoryDropdownSelectClickAction(categoryDropdownClickData);
    };

    
    const CatalogRangeBlock = () => {
        const minRangeString = catalogRange
            && getFormattedAmountWithCurrency(intl, catalogStartRange, tempCurrency);
        const maxRangeString = catalogRange
            && getFormattedAmountWithCurrency(intl, catalogEndRange, tempCurrency);

        return (
            (!Number.isNaN(catalogStartRange) || !Number.isNaN(catalogEndRange))
                ? (
                    <>
                        { !hideDenomPicker && (
                            <Divider
                                component="span"
                                orientation="vertical"
                                flexItem
                                className="custom-vertical-divider"
                                sx={{ display: { xs: 'block', sm: 'block' } }}
                            />
                        )}
                        <Typography>
                            {minRangeString}
                            —
                            {maxRangeString}
                        </Typography>
                    </>
                )
                : null
        );
    };

    return (
        <>
            <Container className='CarouselContainer'>
                <Grid container className='gift-card-title-catalog-wrapper'>
                    <Grid item sx={8} sm={12}>
                        <SkeletonLoader
                            isLoading={isLoading}
                            skeletonProps={{
                                animation: 'wave',
                                variant: 'text',
                                className: 'skeletonclass',
                                height: 40,
                                width: 100
                            }}
                        >
                            <Typography variant="h2" className='gift-cards-type-title'>
                                {giftCardMainTitle}
                            </Typography>
                        </SkeletonLoader>
                    </Grid>
                    <Grid item sx={{ display: { xs: 'flex', sm: 'flex' } }} sm={12} className='catalog-range-block'>
                        <SkeletonLoader
                            isLoading={isLoading}
                            skeletonProps={{
                                animation: 'wave',
                                variant: 'text',
                                className: 'skeletonclass',
                                height: 40,
                                width: 100
                            }}
                        >
                            { !hidePicker && (
                                <>
                                    { !hideDenomPicker && (
                                        <DenomCurrencyPicker
                                            cardDeliveryType={cardDeliveryType}
                                            tempCurrency={tempCurrency}
                                            setTempCurrency={setTempCurrency}
                                            isSetCurrency={isSetCurrency}
                                        />
                                    )}
                                    <CatalogRangeBlock />
                                </>
                            )
                            }
                        </SkeletonLoader>
                    </Grid>
                </Grid>
                {
                    hidePicker
                    && <Alert severity="error" className='currency-not-exists-in-list'>{intl.formatMessage(homePageV2Messages.currencyNotExistsInList, { cardDeliveryType, selectedCurrency })}</Alert>
                }
                {(faceplatesCount > 1 || categoryCount > 1) && (
                    <Box>
                        {}
                        <GiftCardDeliveryTypeOptions
                            giftCardDeliveryType={giftCardDeliveryType}
                            isLoading={isLoading}
                        />
                    </Box>
                )}
                <Box>
                    {}
                    <CategoryTabsCarouselContainer
                        categories={categories}
                        handleSubmit={handleSubmit}
                        giftCardDeliveryType={giftCardDeliveryType}
                        categoryCount={categoryCount}
                        faceplatesCount={faceplatesCount}
                        setFaceplatesCount={setFaceplatesCount}
                        isLoading={isLoading}
                        callbackOnCategorySelectOrClose={callbackOnCategorySelectOrClose}
                        tempCurrency={tempCurrency}
                        shouldSetCurrency={!hidePicker}
                    />
                </Box>

                {
                    isPhotoSupported && (
                        <UYOButton
                            onClick={() => {
                                saveSelectedCardType(isPhysicalCard ? CARD_TYPES.Physical : CARD_TYPES.Digital);
                                if (!uyoFaceplate) {
                                    saveSelectedCardOnBuyButtonClickAction(defaultCategory,
                                        defaultFaceplate,
                                        'UYO',
                                        isPhysicalCard);
                                }
                                setClickedOnUYOAction(true); 
                                handleSubmit(isPhysicalCard, true);
                                trackAddAnotherButton('Upload Your Own Photo', HOME_STEP, 'Homepage');
                            }}
                        />
                    )

                }

                <Grid className='buyGiftCardButton'>
                    <SkeletonLoader
                        isLoading={isLoading}
                        skeletonProps={{
                            animation: 'wave',
                            variant: 'rectangular',
                            className: 'skeletonclass',
                            width: 184,
                            height: 56
                        }}
                    >
                        {!hidePicker
                            && (
                                <Button
                                    variant='contained'
                                    className='submitButton'
                                    onClick={() => {
                                        saveSelectedCardType(isPhysicalCard ? CARD_TYPES.Physical : CARD_TYPES.Digital);
                                        if (isPhysicalCard && remainingPlasticCardsAllowed === 0) {
                                            handleMaxLimitModalOpen();
                                            return;
                                        }
                                        
                                        
                                        if (!getPhase2Preferred() && isPhysicalCard) {
                                            saveSelectedCardOnBuyButtonClickAction('',
                                                IMap(),
                                                submitButtonName,
                                                isPhysicalCard);
                                            handleClickForModal();
                                        } else {
                                            CTAButtonOnClick(defaultFaceplate, submitButtonName, isPhysicalCard);
                                        }
                                    }}
                                >
                                    {submitButtonName}
                                </Button>
                            )}
                    </SkeletonLoader>
                </Grid>
            </Container>
            {isDialogOpen && (
                <SiteSwitchDialog
                    physicalCard
                    isOpen={isDialogOpen}
                    handleCloseModel={handleCloseModel}
                />
            )}
            {isMaxPhysicalItemModalOpen && (
                <SiteSwitchDialog
                    physicalCard
                    isOpen={isMaxPhysicalItemModalOpen}
                    handleCloseModel={handleMaxLimitModalClose}
                    isPhysicalcartMaxlimitReached={isMaxPhysicalItemModalOpen}
                    onConfirmCTA={() => CTAButtonOnClick(remainingPlasticCardsAllowed === 0
                        ? digitalPrimaryFaceplate : defaultFaceplate, submitButtonName, false)
                    }
                    cartMaxNumPlasticCards={cartMaxNumPlasticCards}
                />
            )}
        </>
    );
};

CarouselContainer.defaultProps = {
    giftCardMainTitle: '',
    giftCardDeliveryType: '',
    submitButtonName: '',
    digitalPrimaryFaceplate: IMap(),
    categories: IList(),
    cartMaxNumPlasticCards: 0,
    physicalPrimaryFacePlate: IMap(),
    uyoEgcPhotoSupported: false,
    uyoPlasticPhotoSupported: false
};

CarouselContainer.propTypes = {
    categories: PropTypes.instanceOf(IList),
    handleSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    giftCardMainTitle: PropTypes.string,
    giftCardDeliveryType: PropTypes.string,
    submitButtonName: PropTypes.string,
    digitalPrimaryFaceplate: PropTypes.instanceOf(IMap),
    saveSelectedCardOnBuyButtonClickAction: PropTypes.func.isRequired,
    categoryDropdownSelectClickAction: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    remainingPlasticCardsAllowed: PropTypes.number.isRequired,
    cartMaxNumPlasticCards: PropTypes.number,
    saveSelectedCardType: PropTypes.func.isRequired,
    physicalPrimaryFacePlate: PropTypes.instanceOf(IMap),
    selectedCurrency: PropTypes.string.isRequired,
    supportedElectronicCurrencyList: PropTypes.instanceOf(IList).isRequired,
    supportedPlasticCurrencyList: PropTypes.instanceOf(IList).isRequired,
    setCurrency: PropTypes.func.isRequired,
    cartCurrencyCode: PropTypes.string.isRequired,
    selectedFaceplate: PropTypes.instanceOf(IMap).isRequired,
    uyoEgcPhotoSupported: PropTypes.bool,
    uyoPlasticPhotoSupported: PropTypes.bool,
    setClickedOnUYOAction: PropTypes.func.isRequired,
    trackAddAnotherButton: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    saveSelectedCardOnBuyButtonClickAction: saveSelectedCardOnBuyButtonClick,
    categoryDropdownSelectClickAction: categoryDropdownSelectClick,
    saveSelectedCardType: selectedCardType,
    setCurrency: setCurrencyActionCreator,
    setClickedOnUYOAction: setClickedOnUYO,
    trackAddAnotherButton: trackButtonClick
};

const mapStateToProps = state => ({
    remainingPlasticCardsAllowed: getRemainingPlasticCardsAllowed(state),
    cartMaxNumPlasticCards: getCartMaxNumPlasticCards(state),
    selectedCurrency: getIntlCurrencyCode(state),
    supportedElectronicCurrencyList: getBrandElectronicCurrencyList(state),
    supportedPlasticCurrencyList: getBrandPlasticCurrencyList(state),
    cartCurrencyCode: getCartCurrencyCode(state),
    uyoEgcPhotoSupported: getUYOEgcPhotoSupported(state),
    uyoPlasticPhotoSupported: getUYOPlasticPhotoSupported(state),
    selectedFaceplate: getSelectedFaceplate(state)
});
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(windowSize(CarouselContainer)));
